import React, { useContext, useEffect, useState } from "react";
import { withTranslation, useTranslation } from "react-i18next";
import { EventContext, LoaderContext, RegulationContext } from "../../../App";
import "./CompanyDashboard.scss";

import 'react-circular-progressbar/dist/styles.css';
import { BiCheckCircle } from "react-icons/bi";
import { MdClose } from "react-icons/md";
import { LS_AUTHORITY_KEY } from "../../../core/constants/common";
import DashGraphConfigService from "../../../core/service/DashGraphConfigService";
import LineGraphImg from "../../../images/Energy Intensity.png";
import BarGraphImg from "../../../images/bar_chart.png";
import StackedBarGraphImg from "../../../images/stacked_bar_chart.png";
import PieGraphImg from "../../../images/pyGraph.png";
import NumberGraphImg from "../../../images/NumberIcon.png";
import QuestionService from "../../../core/service/QuestionService";



const WidgetLibraryPanel = ({ t, category, renderedOn, onHide, onAdd, type }) => {
  const authority = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
  const companyId = authority.profile.company.id;

  const { glbRegulation } = useContext(RegulationContext);
  const { setLoaderDisplay } = useContext(LoaderContext);
  const { setEvent } = useContext(EventContext);
  const [graphs, setGraphs] = useState({});
  const { k, i18n } = useTranslation();
  useEffect(() => {
    if (category || renderedOn >= 0 || type === 'REPORTING_STUDIO') {
      getGraphConfig();
    }
  }, [category, renderedOn, type]);

  const getGraphConfig = (selectedCat = 'ENVIRONMENTAL') => {
    setLoaderDisplay(true);

    let cat = '';
    if (type === 'REPORTING_STUDIO') {
      cat = selectedCat;
    } else {
      cat = category === 'Social'
        ? 'SOCIAL' : category === 'Governance'
          ? 'GOVERNANCE' : 'ENVIRONMENTAL';
    }

    DashGraphConfigService.getCompanyGraphs(companyId, glbRegulation.id, cat, glbRegulation?.name, null, false, false, true)
      .then(res => {
        setLoaderDisplay(false);
        if (res.status !== 200) return;
        const graphs = res.data?.graphs ?? [];
        const transformedData = graphs.map((objDat) => transformObject(objDat)); 
        const groupedGraphs = transformedData.reduce((groups, graph) => {
          const topic = graph.topicName;
          if (!groups[topic]) {
            groups[topic] = [];
          }
          groups[topic].push(graph);
          return groups;
        }, {});
        setGraphs(groupedGraphs);
      }).catch(err => {
        setLoaderDisplay(false);
      });
  };

  const transformObject = (obj) => {
    const transformedObj = { ...obj };
    // Add the translated values to the main object based on languageCode
    if (obj.localizedContents && obj.localizedContents.length > 0) {
        obj.localizedContents.forEach((item) => {
            if (item.fieldName === 'title') {
                transformedObj[item.languageCode] = item.translatedValue;
            } else if (item.fieldName === 'description') {
              transformedObj[`${item.languageCode}_description`] = item.translatedValue;
          }
        });
    }
    return transformedObj;
};

  const onActivate = (graph) => {
    if (graph.active) return;

    DashGraphConfigService.activateGraph(graph.id, true).then(res => {
      if (res.status !== 200) return;

      onAdd();
    }).catch(err => { });
  };

  return (
    <>
      <div className="AddWidgetsDashboardHead p-3">
        <div className="d-flex justify-content-between">
          <h6 className="m-0">{type !== 'REPORTING_STUDIO' ? t('AddWidgets.label') : t('AddGraphs.label')}</h6>
          {type !== 'REPORTING_STUDIO' && <MdClose className="cursor" onClick={() => onHide()} />}
          {
            type === 'REPORTING_STUDIO' &&
            <div>
              {/* <label className="mb-1">{t('Category.label')}</label> */}
              <select className="form-select " onChange={(e) => getGraphConfig(e.target.value)}>
                <option value="ENVIRONMENTAL" key="Environmental">{t("Environmental.label")}</option>
                <option value="SOCIAL" key="Social">{t("Social.label")}</option>
                <option value="GOVERNANCE" key="Governance">{t("Governance.label")}</option>
              </select>
            </div>
          }
        </div>
      </div>
      <div className="px-3 pb-3">
        {type !== 'REPORTING_STUDIO' && <p>{t('WidgetLibPanelSubheading.label')}</p>}
        {
          Object.keys(graphs)?.map((k) => {
            return (
              <div key={`topicHolder-${k}`}>
                <p className="text-primary fw-bold">{k}</p>
                {
                  graphs[k]?.map((graph, gIndex) => {
                    return (
                      <div key={`graph-${k}-${gIndex}`}
                        className={`card GraphWidgetsBox p-2 mb-2 cursor ${graph.active && type !== 'REPORTING_STUDIO' ? 'bg-muted' : ''}`}
                        onClick={() => type === 'REPORTING_STUDIO' ? onAdd(graph) : onActivate(graph)}>
                        {graph.active && type !== 'REPORTING_STUDIO' && <span className='assigned-icon text-success'><BiCheckCircle /></span>}
                        <div className="GraphWidgetsBox_img">
                          <img
                            src={
                              graph.type === 'STACKED BAR' ? StackedBarGraphImg : graph.type === 'BAR' ? BarGraphImg : graph.type === 'PIE' ? PieGraphImg : graph.type === 'LINE' ? LineGraphImg : NumberGraphImg
                            }
                          />
                        </div>
                        <div className="GraphWidgetsBox_dt ps-2">
                          <p className="fw-bold m-0">
                          {(i18n.language && graph[i18n.language]) ? graph[i18n.language] : graph?.title}
                            </p>
                          <p className="m-0">
                          {(i18n.language && graph[`${i18n.language}_description`]) 
                          ? graph[`${i18n.language}_description`] : graph?.description}
                            </p>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            )
          })
        }
        {Object.keys(graphs)?.length === 0 && <p>{type === 'REPORTING_STUDIO' ? t('NoGraphs.label') : t('NoWidgets.label')}</p>}
      </div>
    </>
  );
};
export default withTranslation()(WidgetLibraryPanel);
